(function () {
  'use strict';

  /* ── Config ─────────────────────────────────────────────── */
  /* Vehicle options come from the Fitment Notes API (Redis-backed), one level
     per request — the full vehicle tree is never shipped to the browser.
     window.YMMConfig.API_BASE is set in layout/theme.liquid. */
  var API_BASE      = ((window.YMMConfig || {}).API_BASE || '').replace(/\/+$/, '');
  var REQUEST_TIMEOUT = 10000;
  var STORAGE_KEY  = 'ymm_recent_vehicles';
  var SESSION_KEY  = 'ymm_active_sel';
  var MY_VEHICLE_KEY = 'ymm_my_vehicle'; /* the saved vehicle shown in the "My Vehicle" bar */
  var MAX_RECENT   = 5;

  /* ── State ──────────────────────────────────────────────── */
  var sel        = {};   /* selected *codes* (API keys), one per level */
  var lab        = {};   /* selected human labels, one per level */
  var loaded     = false;
  var mapsReady  = false;
  var seq        = 0;    /* bumped on every change so stale responses are dropped */
  var cache      = {};   /* in-flight requests, per page view: path -> Promise<{code: label}> */

  /* ── DOM refs ────────────────────────────────────────────── */
  var elPanel, elOverlay, elTrigger, elClose;
  var elLoading, elError, elRecent, elRecentList, elForm;
  var elAccordionToggle, elAccordionBody;
  var selYear, selMake, selModel, selCT, selCN, selPG, selPSG;
  var fieldCT, fieldCN, fieldPG, fieldPSG;
  var btnConfirm;

  /* ── Dropdown map (populated after DOM ready) ────────────── */
  var SELECT_MAP = {};
  var FIELD_MAP  = {};

  var LEVELS = ['year', 'make', 'model', 'ct', 'cn', 'pg', 'psg'];

  /* Confirm needs all of these. Component Type / Name are always visible (disabled
     until the step before is chosen); Part Group / Sub-Group stay optional and only
     appear when the API has options for them. */
  var REQUIRED     = ['year', 'make', 'model', 'ct', 'cn'];
  var ALWAYS_SHOWN = { ct: true, cn: true };

  /* All five are strictly required: if the API has no options for one of them (a year
     with no makes, a component type with no component names…) the field stays visible
     as "No options available" and Confirm stays blocked. Only Part Group / Sub-Group are
     optional and may disappear. */

  var PLACEHOLDERS = {
    year  : 'Select Year',
    make  : 'Select Make',
    model : 'Select Model',
    ct    : 'Select Component Type',
    cn    : 'Select Component Name',
    pg    : 'Select Part Group',
    psg   : 'Select Part Sub-Group',
  };

  /* ════════════════════════════════════════════════════════
     INIT
  ════════════════════════════════════════════════════════ */
  function init() {
    elPanel       = document.getElementById('ymm-panel');
    if (!elPanel) return;

    elOverlay        = document.getElementById('ymm-overlay');
    elTrigger        = document.getElementById('ymm-trigger');
    elClose          = document.getElementById('ymm-close');
    elLoading        = document.getElementById('ymm-loading');
    elError          = document.getElementById('ymm-error');
    elRecent         = document.getElementById('ymm-recent');
    elRecentList     = document.getElementById('ymm-recent-list');
    elForm           = document.getElementById('ymm-form');
    elAccordionToggle= document.getElementById('ymm-accordion-toggle');
    elAccordionBody  = document.getElementById('ymm-accordion-body');

    selYear  = document.getElementById('ymm-year');
    selMake  = document.getElementById('ymm-make');
    selModel = document.getElementById('ymm-model');
    selCT    = document.getElementById('ymm-ct');
    selCN    = document.getElementById('ymm-cn');
    selPG    = document.getElementById('ymm-pg');
    selPSG   = document.getElementById('ymm-psg');

    fieldCT  = document.getElementById('ymm-ct-field');
    fieldCN  = document.getElementById('ymm-cn-field');
    fieldPG  = document.getElementById('ymm-pg-field');
    fieldPSG = document.getElementById('ymm-psg-field');

    btnConfirm = document.getElementById('ymm-confirm');

    initMaps();

    /* Bind events */
    elTrigger.addEventListener('click', openPanel);
    elClose.addEventListener('click', closePanel);
    elOverlay.addEventListener('click', closePanel);
    elAccordionToggle.addEventListener('click', toggleAccordion);
    btnConfirm.addEventListener('click', onConfirm);

    var clearSelBtn = document.getElementById('ymm-clear-selection');
    if (clearSelBtn) clearSelBtn.addEventListener('click', clearActiveSelection);

    /* Show clear button immediately if a session selection exists */
    try {
      if ((sessionStorage.getItem(SESSION_KEY) || localStorage.getItem(MY_VEHICLE_KEY)) && clearSelBtn) clearSelBtn.hidden = false;
    } catch (e) {}

    LEVELS.forEach(function (level) {
      SELECT_MAP[level].addEventListener('change', function () { onLevelChange(level); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    /* The old implementation cached the whole vehicle JSON in IndexedDB.
       Drop that leftover copy from returning visitors' browsers. */
    try { indexedDB.deleteDatabase('ymm_store'); } catch (e) {}

    if (location.protocol === 'https:' && /^http:/i.test(API_BASE)) {
      console.error('[YMM Widget] API_BASE is plain http on an https page — the browser will block these requests as mixed content.');
    }

    /* The My Vehicle bar has no button; the whole bar opens the panel (mouse, touch, keyboard) */
    var vehicleBar = document.getElementById('ymm-vehicle-bar');
    if (vehicleBar) {
      vehicleBar.addEventListener('click', openPanel);
      vehicleBar.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPanel(); }
      });
    }

    var selectBarBtn = document.getElementById('ymm-select-bar-btn');
    if (selectBarBtn) selectBarBtn.addEventListener('click', openPanel);

    restoreSessionDisplay();
    renderVehicleBar();
  }

  function initMaps() {
    if (mapsReady) return;
    SELECT_MAP.year  = selYear;
    SELECT_MAP.make  = selMake;
    SELECT_MAP.model = selModel;
    SELECT_MAP.ct    = selCT;
    SELECT_MAP.cn    = selCN;
    SELECT_MAP.pg    = selPG;
    SELECT_MAP.psg   = selPSG;
    FIELD_MAP.ct     = fieldCT;
    FIELD_MAP.cn     = fieldCN;
    FIELD_MAP.pg     = fieldPG;
    FIELD_MAP.psg    = fieldPSG;
    mapsReady = true;
  }

  /* ════════════════════════════════════════════════════════
     API  — GET /api/lookup/... returns { code: "Label" }.
     An empty object means "nothing further at this level".
     Path segments are the *codes* from the previous responses.
  ════════════════════════════════════════════════════════ */
  function levelPath(level) {
    var e = encodeURIComponent;
    var base = '/api/lookup/';
    var vehicle = e(sel.year) + '/' + e(sel.make) + '/' + e(sel.model);

    switch (level) {
      case 'year'  : return base + 'years';
      case 'make'  : return base + e(sel.year) + '/make';
      case 'model' : return base + e(sel.year) + '/' + e(sel.make) + '/model';
      case 'ct'    : return base + vehicle + '/componentType';
      case 'cn'    : return base + vehicle + '/' + e(sel.ct) + '/componentName';
      /* Part group / sub-group exist both with and without a component name —
         the name segment is only present when the CN dropdown had options. */
      case 'pg'    : return base + vehicle + '/' + e(sel.ct) + (sel.cn ? '/' + e(sel.cn) : '') + '/partgroup';
      case 'psg'   : return base + vehicle + '/' + e(sel.ct) + (sel.cn ? '/' + e(sel.cn) : '') + '/' + e(sel.pg) + '/partsubgroup';
    }
    return '';
  }

  /* Lookup answers are kept in sessionStorage (shared by the header widget and the
     results-page vehicle filters — same key, same format), so re-opening the widget
     or landing on another page replays the saved selection with no API calls. An
     entry is just "the options at this path", so changing a selection only fetches
     the paths that are new; everything unchanged is reused. Entries expire after an
     hour so a backend data reload is picked up, and the cache dies with the tab. */
  var LOOKUP_CACHE_KEY = 'ymm_lookup_cache';
  var LOOKUP_CACHE_TTL = 60 * 60 * 1000;

  function lookupCacheGet(path) {
    try {
      var all = JSON.parse(sessionStorage.getItem(LOOKUP_CACHE_KEY) || '{}');
      var hit = all[path];
      if (hit && Date.now() - hit.t < LOOKUP_CACHE_TTL) return hit.d;
    } catch (e) {}
    return null;
  }

  function lookupCacheSet(path, data) {
    try {
      var all = JSON.parse(sessionStorage.getItem(LOOKUP_CACHE_KEY) || '{}');
      var now = Date.now();
      Object.keys(all).forEach(function (p) { if (now - all[p].t >= LOOKUP_CACHE_TTL) delete all[p]; });
      all[path] = { t: now, d: data };
      sessionStorage.setItem(LOOKUP_CACHE_KEY, JSON.stringify(all));
    } catch (e) { /* storage full or blocked — just means no persistence */ }
  }

  function fetchOptions(level) {
    var path = levelPath(level);

    var saved = lookupCacheGet(path);
    if (saved) return Promise.resolve(saved);

    if (!cache[path]) {
      cache[path] = fetchJson(API_BASE + path, 1)
        .then(function (data) { lookupCacheSet(path, data); return data; })
        .catch(function (err) {
          delete cache[path]; /* don't cache failures */
          throw err;
        });
    }
    return cache[path];
  }

  /* One retry on a transient failure (timeout, dropped connection, 5xx). */
  function fetchJson(url, retries) {
    var ctrl  = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT) : null;

    return fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (timer) clearTimeout(timer);
        return data && typeof data === 'object' ? data : {};
      })
      .catch(function (err) {
        if (timer) clearTimeout(timer);
        if (retries > 0) {
          return new Promise(function (resolve) { setTimeout(resolve, 400); })
            .then(function () { return fetchJson(url, retries - 1); });
        }
        throw err;
      });
  }

  /* ════════════════════════════════════════════════════════
     DROPDOWN CASCADE  — Year → Make → Model → CT → CN → PG → PSG
     Each change loads the next level from the API; an empty response ends
     the chain (or, for Component Name, skips straight to Part Group).
  ════════════════════════════════════════════════════════ */
  function sortedEntries(level, opts) {
    var entries = Object.keys(opts).map(function (code) { return { code: code, label: String(opts[code]) }; });
    entries.sort(function (a, b) {
      if (level === 'year') return Number(b.label) - Number(a.label);
      return a.label.localeCompare(b.label);
    });
    return entries;
  }

  function populate(level, opts) {
    var select = SELECT_MAP[level];
    resetSelect(select, PLACEHOLDERS[level]);
    sortedEntries(level, opts).forEach(function (o) {
      select.add(new Option(o.label, o.code));
    });
    select.disabled = false;
    if (FIELD_MAP[level]) FIELD_MAP[level].hidden = false;
  }

  function loadLevel(level) {
    var id = ++seq;
    var select = SELECT_MAP[level];

    hideError();
    resetSelect(select, '');
    if (FIELD_MAP[level]) FIELD_MAP[level].hidden = false;

    return fetchOptions(level)
      .then(function (opts) {
        if (id !== seq) return false; /* superseded by a newer selection */

        if (!Object.keys(opts).length) {
          if (level === 'pg' || level === 'psg') {
            resetSelect(select, PLACEHOLDERS[level]);
            if (FIELD_MAP[level]) FIELD_MAP[level].hidden = true;
            syncConfirm();
            return false;
          }

          /* A required level with nothing to choose (e.g. a year with no makes, a
             component type with no component names): keep the field visible and say
             so — the flow stays blocked rather than the field disappearing. */
          resetSelect(select, 'No options available');
          syncConfirm();
          return false;
        }

        populate(level, opts);
        syncConfirm();
        return true;
      })
      .catch(function (err) {
        if (id !== seq) return false;
        resetSelect(select, PLACEHOLDERS[level]);
        if (FIELD_MAP[level]) FIELD_MAP[level].hidden = !ALWAYS_SHOWN[level];

        /* The API currently answers 500 (instead of {}) for part group / sub-group
           when a vehicle has none. These are optional last steps, so treat the
           failure as "end of chain" rather than blocking the shopper with an error. */
        if (level === 'pg' || level === 'psg') {
          console.warn('[YMM Widget] No ' + level + ' options (treated as end of chain):', err);
          syncConfirm();
          return false;
        }

        showError('Could not load vehicle options. Please try again.');
        console.error('[YMM Widget]', level, err);
        return false;
      });
  }

  function advance(from) {
    var next = LEVELS[LEVELS.indexOf(from) + 1];
    if (!next) { syncConfirm(); return Promise.resolve(false); }
    return loadLevel(next);
  }

  function onLevelChange(level) {
    var select = SELECT_MAP[level];
    var next   = LEVELS[LEVELS.indexOf(level) + 1];

    seq++;
    if (next) resetFrom(next);

    if (!select.value) {
      delete sel[level];
      delete lab[level];
      syncConfirm();
      return;
    }

    sel[level] = select.value;
    lab[level] = select.options[select.selectedIndex].text;
    advance(level);
  }

  /* ════════════════════════════════════════════════════════
     CONFIRM  — saves full selection, updates recent vehicles
  ════════════════════════════════════════════════════════ */
  function onConfirm() {
    /* Labels go into the ymm_ctx URL so it stays readable, and so results.js's
       own label->code lookup (against whichever per-make product file it
       loads) stays decoupled from the API's code vocabulary. The *_code
       fields carry the API codes through so "Shop Parts" (recent vehicles)
       can replay the dropdown cascade, which is keyed by code. */
    var result = {
      year           : lab.year  || '',
      make           : lab.make  || '',
      model          : lab.model || '',
      component_type : lab.ct    || '',
      component_name : lab.cn    || '',
      part_group     : lab.pg    || '',
      part_sub_group : lab.psg   || '',
      make_code      : sel.make  || '',
      model_code     : sel.model || '',
      component_type_code : sel.ct  || '',
      component_name_code : sel.cn  || '',
      part_group_code     : sel.pg  || '',
      part_sub_group_code : sel.psg || '',
    };

    saveToRecent(result);
    saveMyVehicle(result);
    updateTriggerVehicle(result);
    renderRecentVehicles();

    var clearSelBtn = document.getElementById('ymm-clear-selection');
    if (clearSelBtn) clearSelBtn.hidden = false;

    /* Persist active selection (codes) so dropdowns restore after navigation */
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        year:  sel.year  || '',
        make:  sel.make  || '',
        model: sel.model || '',
        ct:    sel.ct    || '',
        cn:    sel.cn    || '',
        pg:    sel.pg    || '',
        psg:   sel.psg   || '',
      }));
    } catch (e) {}

    /* Redirect to results page — labels only in ymm_ctx */
    window.location.href = buildResultsUrl(result);
  }

  /* ════════════════════════════════════════════════════════
     YMM_CTX  — Year-Make-Model-CT-CN-PG-PSG, labels only, joined with "-".
     Each label is percent-encoded and any hyphen *inside* a label is escaped
     (as %252D, which URLSearchParams decodes once to %2D) so it can't be mistaken
     for the separator; results.js turns %2D back into "-" after splitting.
     Trailing empty segments are dropped. (Older links used "|" and Make|Model|Year.)
  ════════════════════════════════════════════════════════ */
  function ctxSegments(v) {
    var parts = [
      v.year, v.make, v.model,
      v.component_type, v.component_name, v.part_group, v.part_sub_group
    ];
    while (parts.length && !parts[parts.length - 1]) parts.pop();
    return parts.map(function (p) { return p || ''; });
  }

  function buildYmmCtx(v) {
    return ctxSegments(v).map(function (p) {
      return encodeURIComponent(p).replace(/-/g, '%252D');
    }).join('-');
  }

  /* ════════════════════════════════════════════════════════
     RESULTS URL  — /pages/ymm-results?ymm_ctx=1992-Chevrolet-2500-Transmission-NV4500
     The URL carries labels only. The results page needs API codes, so when this
     vehicle's codes are known they are cached in sessionStorage under the decoded
     ymm_ctx value (the same key results.js reads); otherwise results.js resolves
     them from the labels through the lookup API.
  ════════════════════════════════════════════════════════ */
  function cacheResultsCodes(v) {
    if (!v.make_code || !v.model_code) return;
    var key = 'ymm_codes:' + ctxSegments(v).map(function (p) { return p.replace(/-/g, '%2D'); }).join('-');
    var codes = [
      v.make_code, v.model_code, v.year,
      v.component_type_code, v.component_name_code, v.part_group_code, v.part_sub_group_code
    ];
    try { sessionStorage.setItem(key, JSON.stringify(codes)); } catch (e) {}
  }

  function buildResultsUrl(v) {
    cacheResultsCodes(v);
    return '/pages/ymm-results?ymm_ctx=' + buildYmmCtx(v);
  }

  /* ════════════════════════════════════════════════════════
     RESET SELECTION FORM  — clears all dropdowns after confirm
  ════════════════════════════════════════════════════════ */
  function resetSelectionForm() {
    seq++;
    sel = {};
    lab = {};
    resetFrom('year');
    if (loaded) loadLevel('year');
    btnConfirm.disabled = true;
  }

  /* ════════════════════════════════════════════════════════
     RECENT VEHICLES  — stored as array in localStorage
  ════════════════════════════════════════════════════════ */
  function getRecentVehicles() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) { return []; }
  }

  function saveToRecent(result) {
    var list = getRecentVehicles();
    /* Remove duplicate if same year/make/model already exists */
    list = list.filter(function (v) {
      return !(v.year === result.year && v.make === result.make && v.model === result.model);
    });
    list.unshift(result); /* Add to front */
    if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function renderRecentVehicles() {
    var list = getRecentVehicles();
    if (!list.length || !elRecent || !elRecentList) return;

    elRecentList.innerHTML = '';
    list.forEach(function (vehicle) {
      var label = vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;

      var item = document.createElement('div');
      item.className = 'ymm-recent__item';

      var info = document.createElement('div');
      info.className = 'ymm-recent__info';

      var name = document.createElement('div');
      name.className = 'ymm-recent__vehicle';
      name.textContent = label;
      info.appendChild(name);

      /* Component Type / Name the vehicle was saved with, under the name */
      var detailText = [vehicle.component_type, vehicle.component_name].filter(Boolean).join(' \u00B7 ');
      if (detailText) {
        var detail = document.createElement('div');
        detail.className = 'ymm-recent__detail';
        detail.textContent = detailText;
        detail.title = detailText;
        info.appendChild(detail);
      }

      /* Shop Parts — redirects to results page for this vehicle */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ymm-recent__shop-link';
      btn.textContent = 'Shop Parts';

      btn.addEventListener('click', function () {
        saveMyVehicle(vehicle);

        /* Save this vehicle as the active selection so dropdowns restore.
           Entries saved before the API switch have no make/model codes, so
           fall back to the labels — restoreCascade matches on either. */
        try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(selectionFromVehicle(vehicle))); } catch (e) {}

        window.location.href = buildResultsUrl(vehicle);
      });

      item.appendChild(info);
      item.appendChild(btn);
      elRecentList.appendChild(item);
    });

    elRecent.hidden = false;
  }

  /* ════════════════════════════════════════════════════════
     ACTIVE SELECTION RESTORE  — replays the cascade from sessionStorage
     one API call per level (responses are cached in memory for the page view)
  ════════════════════════════════════════════════════════ */
  function selectionFromVehicle(vehicle) {
    return {
      year:  vehicle.year                 || '',
      make:  vehicle.make_code            || vehicle.make  || '',
      model: vehicle.model_code           || vehicle.model || '',
      ct:    vehicle.component_type_code  || '',
      cn:    vehicle.component_name_code  || '',
      pg:    vehicle.part_group_code      || '',
      psg:   vehicle.part_sub_group_code  || ''
    };
  }

  function restoreActiveSelection() {
    try {
      var stored = sessionStorage.getItem(SESSION_KEY);
      var s = stored ? JSON.parse(stored) : null;

      /* A new tab / browser session has no active selection, but the saved vehicle (the
         one the My Vehicle bar shows) lives in localStorage — restore from that, so the
         panel always matches the bar. */
      if (!s || !s.year || !s.make || !s.model) {
        var mine = JSON.parse(localStorage.getItem(MY_VEHICLE_KEY) || 'null');
        if (!mine || !mine.year || !mine.make || !mine.model) return;
        s = selectionFromVehicle(mine);
        try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(s)); } catch (e) {}
      }
      restoreCascade(s);
    } catch (e) {}
  }

  /* Match a stored value against an option's code or (case-insensitively) its label */
  function findOption(select, want) {
    var w = String(want).toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      if (!o.value) continue;
      if (o.value === want || o.text.toLowerCase() === w) return o;
    }
    return null;
  }

  function restoreCascade(s) {
    function step(i) {
      if (i >= LEVELS.length) return Promise.resolve();
      var level  = LEVELS[i];
      var select = SELECT_MAP[level];
      var field  = FIELD_MAP[level];

      /* Level was skipped/ended by the API (hidden field) — nothing to restore here */
      if (field && field.hidden) return step(i + 1);

      var want = s[level];
      if (!want) { syncConfirm(); return Promise.resolve(); }

      var opt = findOption(select, want);
      if (!opt) { syncConfirm(); return Promise.resolve(); }

      select.value = opt.value;
      sel[level] = opt.value;
      lab[level] = opt.text;
      return advance(level).then(function () { return step(i + 1); });
    }

    step(0);
  }

  /* ════════════════════════════════════════════════════════
     SESSION PERSISTENCE
  ════════════════════════════════════════════════════════ */
  function restoreSessionDisplay() {
    var list = getRecentVehicles();
    if (!list.length) return;
    /* Show most recent vehicle on trigger button */
    updateTriggerVehicle(list[0]);
    renderRecentVehicles();
  }

  /* ════════════════════════════════════════════════════════
     MY VEHICLE BAR  — slim sticky strip under the header (markup in
     snippets/ymm-vehicle-bar.liquid, not rendered on the homepage). Shows the
     saved vehicle's labels; "Change" opens this panel. Hidden when no vehicle
     is saved; Clear Selection removes it.
  ════════════════════════════════════════════════════════ */
  function saveMyVehicle(v) {
    try { localStorage.setItem(MY_VEHICLE_KEY, JSON.stringify(v)); } catch (e) {}
    renderVehicleBar();
  }

  function getMyVehicle() {
    try {
      var mine = JSON.parse(localStorage.getItem(MY_VEHICLE_KEY) || 'null');
      if (mine && mine.year && mine.make && mine.model) return mine;

      /* Shoppers who picked a vehicle before the bar existed: fall back to their
         latest recent vehicle while the session still has an active selection. */
      if (sessionStorage.getItem(SESSION_KEY)) {
        var recent = getRecentVehicles()[0];
        if (recent && recent.year && recent.make && recent.model) return recent;
      }
    } catch (e) {}
    return null;
  }

  function renderVehicleBar() {
    var v = getMyVehicle();

    /* Header button: "Select Your Vehicle" until a vehicle is saved, then "Change Vehicle" */
    var triggerText = document.querySelector('.ymm-trigger__text');
    if (triggerText) triggerText.textContent = v ? 'Change Vehicle' : 'Select Your Vehicle';

    var bar    = document.getElementById('ymm-vehicle-bar');
    var values = document.getElementById('ymm-vehicle-bar-values');
    var hasVehicleBar = !!(bar && values);

    /* Phone-only "Select Your Vehicle" bar: the phone entry point to the widget. It steps
       aside only when the My Vehicle bar is there to take over (so a shopper with a saved
       vehicle never ends up with no bar at all). */
    var selectBar = document.getElementById('ymm-select-bar');
    if (selectBar) selectBar.hidden = !!v && hasVehicleBar;

    if (!hasVehicleBar) return;

    if (!v) { bar.hidden = true; return; }

    values.innerHTML = '';
    [v.year, v.make, v.model, v.component_type, v.component_name, v.part_group, v.part_sub_group]
      .filter(Boolean)
      .forEach(function (text) {
        var chip = document.createElement('span');
        chip.className = 'ymm-vehicle-bar__value';
        chip.textContent = text;
        values.appendChild(chip);
      });

    bar.hidden = false;
  }

  /* ════════════════════════════════════════════════════════
     ACCORDION TOGGLE
  ════════════════════════════════════════════════════════ */
  function toggleAccordion() {
    var expanded = elAccordionToggle.getAttribute('aria-expanded') === 'true';
    elAccordionToggle.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      elAccordionBody.classList.add('is-collapsed');
    } else {
      elAccordionBody.classList.remove('is-collapsed');
    }
  }

  function collapseAccordion() {
    elAccordionToggle.setAttribute('aria-expanded', 'false');
    elAccordionBody.classList.add('is-collapsed');
  }

  /* ════════════════════════════════════════════════════════
     UI HELPERS
  ════════════════════════════════════════════════════════ */
  function updateTriggerVehicle() {
    /* intentionally blank — the header button's label is kept in step by renderVehicleBar() */
  }

  function clearActiveSelection() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    try { localStorage.removeItem(MY_VEHICLE_KEY); } catch (e) {}
    renderVehicleBar();
    var clearSelBtn = document.getElementById('ymm-clear-selection');
    if (clearSelBtn) clearSelBtn.hidden = true;
    resetSelectionForm();
    closePanel();
  }

  function syncConfirm() {
    btnConfirm.disabled = !REQUIRED.every(function (level) {
      return sel[level];
    });
  }

  function resetSelect(select, placeholder) {
    select.innerHTML = '';
    select.add(new Option(placeholder, ''));
    select.disabled = true;
  }

  /* Resets fromLevel and everything after it back to its placeholder */
  function resetFrom(fromLevel) {
    var startIdx = LEVELS.indexOf(fromLevel);
    if (startIdx === -1) return;

    LEVELS.slice(startIdx).forEach(function (level) {
      resetSelect(SELECT_MAP[level], PLACEHOLDERS[level]);
      if (FIELD_MAP[level]) FIELD_MAP[level].hidden = !ALWAYS_SHOWN[level];
      delete sel[level];
      delete lab[level];
    });
  }

  function showLoading(show) {
    if (elLoading) elLoading.hidden = !show;
  }

  function showError(msg) {
    if (!elError) return;
    elError.textContent = msg;
    elError.hidden = false;
  }

  function hideError() {
    if (elError) elError.hidden = true;
  }

  /* ════════════════════════════════════════════════════════
     PANEL OPEN / CLOSE
  ════════════════════════════════════════════════════════ */
  function openPanel() {
    elPanel.classList.add('is-open');
    elOverlay.classList.add('is-open');
    document.body.classList.add('ymm-open');
    if (elTrigger) elTrigger.setAttribute('aria-expanded', 'true');

    /* Lazy-load the year list on first open (first API call) */
    if (!loaded) loadYears();
  }

  function loadYears() {
    if (!API_BASE) {
      showError('Vehicle data URL is missing. Please check the YMM configuration.');
      console.error('[YMM Widget] Missing API_BASE');
      return;
    }

    showLoading(true);
    loadLevel('year').then(function (ok) {
      showLoading(false);
      if (!ok) return;
      loaded = true;
      restoreActiveSelection();
    });
  }

  function closePanel() {
    elPanel.classList.remove('is-open');
    elOverlay.classList.remove('is-open');
    document.body.classList.remove('ymm-open');
    if (elTrigger) elTrigger.setAttribute('aria-expanded', 'false');
  }

  /* ════════════════════════════════════════════════════════
     BOOT
  ════════════════════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
